module.exports = __webpack_public_path__ + "img/juliaAndAlexanderRing@2x.268598e.webp";